import { useAuthStore, useTenantStore } from '@/store';

export const useMasterTenant = () => {
  const isMaster = () => {
    return useTenantStore().tenant?.id === useAuthStore().masterTenantId;
  };

  return { isMaster };
};
